import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PopularCategories = () => {
  const categories = [
    {
      id: 1,
      name: "Snack",
      image: "/images/categories/item_1.png",
      fallbackImage: "https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=765&auto=format&fit=crop"
    },
    {
      id: 2,
      name: "Chaise",
      image: "/images/categories/item_2.png",
      fallbackImage: "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?q=80&w=687&auto=format&fit=crop"
    },
    {
      id: 3,
      name: "Téléphone intelligent",
      image: "/images/categories/item_3.png",
      fallbackImage: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=880&auto=format&fit=crop"
    },
    {
      id: 4,
      name: "Boisson",
      image: "/images/categories/item_4.png",
      fallbackImage: "https://images.unsplash.com/photo-1554866585-6d94860890b7?q=80&w=1000&auto=format&fit=crop"
    },
    {
      id: 5,
      name: "Chaussures",
      image: "/images/categories/item_5.png",
      fallbackImage: "https://images.unsplash.com/photo-1549298916-b41d501d3772?q=80&w=1000&auto=format&fit=crop"
    },
    {
      id: 6,
      name: "Beauté",
      image: "/images/categories/item_6.png",
      fallbackImage: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?q=80&w=1000&auto=format&fit=crop"
    },
    {
      id: 7,
      name: "Alimentation",
      image: "/images/categories/item_7.png",
      fallbackImage: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?q=80&w=1000&auto=format&fit=crop"
    },
    {
      id: 8,
      name: "Vêtements",
      image: "/images/categories/item_8.png",
      fallbackImage: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=1000&auto=format&fit=crop"
    },
    {
        id: 9,
        name: "Chaise",
        image: "/images/categories/item_9.png",
        fallbackImage: "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?q=80&w=687&auto=format&fit=crop"
      },
      {
        id: 10,
        name: "Téléphone intelligent",
        image: "/images/categories/item_10.png",
        fallbackImage: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=880&auto=format&fit=crop"
      },
  ];

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      }
    ],
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <section className="py-8">
      <div className="container mx-auto px-8 lg:px-4">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Catégories populaires</h2>
        </div>

        {/* Categories Carousel */}
        <div className="relative">
          <style jsx>{`
            .categories-slider .slick-slide {
              padding: 0 8px;
            }
            .categories-slider .slick-track {
              display: flex;
              align-items: stretch;
            }
            .categories-slider .slick-slide > div {
              height: 100%;
            }
            .categories-slider .slick-slide > div > div {
              height: 100%;
            }
            .categories-slider .slick-arrow {
              border-radius: 50%;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
              z-index: 10;
            }
            .categories-slider .slick-arrow:hover {
              box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            }
            .categories-slider .slick-arrow:before {
              display: none;
            }
            .categories-slider .slick-prev {
              left: -20px;
            }
            .categories-slider .slick-next {
              right: -30px;
            }
          `}</style>
          
          <Slider {...settings} className="categories-slider">
            {categories.map((category) => (
              <div key={category.id}>
                <div className="rounded-lg p-0 shadow-sm hover:shadow-md transition-shadow cursor-pointer h-full">
                  {/* Category Image */}
                  <div className="w-full h-32 mb-3 flex items-center justify-center">
                    <img
                      src={category.image}
                      alt={category.name}
                      className="w-full h-full object-cover rounded-lg"
                      onError={(e) => {
                        e.target.src = category.fallbackImage;
                      }}
                    />
                  </div>
                  
                  
                </div>
                {/* Category Name */}
                <p className="mt-3 text-sm font-medium text-gray-700 text-center">
                    {category.name}
                  </p>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

// Custom Arrow Components
const NextArrow = ({ className, style, onClick }) => (
  <button
    className={`${className} absolute -right-12 top-1/2 transform -translate-y-1/2 bg-red-600 rounded-full p-2 shadow-md hover:shadow-lg transition-shadow z-10`}
    style={{ ...style }}
    onClick={onClick}
  >
    <svg className="w-5 h-5 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </button>
);

const PrevArrow = ({ className, style, onClick }) => (
  <button
    className={`${className} absolute -left-12 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:shadow-lg transition-shadow z-10`}
    style={{ ...style }}
    onClick={onClick}
  >
    <svg className="w-5 h-5 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
    </svg>
  </button>
);

export default PopularCategories; 